import { render, staticRenderFns } from "./NewAyudaPagos.vue?vue&type=template&id=4d196c3b&scoped=true"
import script from "./NewAyudaPagos.vue?vue&type=script&lang=js"
export * from "./NewAyudaPagos.vue?vue&type=script&lang=js"
import style0 from "./NewAyudaPagos.vue?vue&type=style&index=0&id=4d196c3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d196c3b",
  null
  
)

export default component.exports